import { isNumberValid } from "@/base/type-guards"
import { getAdjacentIds } from "@/components/device-profile/DeviceCycler"
import * as Models from "@/redux/models"
import { useRootSelector } from "@/redux/useRootSelector"
import type { IconButtonStyleProps, RowProps } from "@/theme"
import { CycleButton, Row } from "@/theme"
import React from "react"

// TODO: Fix this
export function FieldCycler({
  _buttons,
  fieldId,
  onChangeField,
  ...rest
}: RowProps & {
  _buttons?: IconButtonStyleProps
  fieldId: number
  onChangeField: Models.SelectFieldHandler
}) {
  // const [fieldId, setFieldId] = React.useState(4)
  // const onChangeField: Models.SelectFieldHandler = (field) => {
  //   setFieldId(field.fieldId)
  // }
  const ids = useRootSelector(Models.farmField.selectIds)
  const adjacentIds = getAdjacentIds({ currentId: fieldId, ids })
  const fieldLeft = useRootSelector((state) =>
    isNumberValid(adjacentIds?.idLeft)
      ? Models.farmField.selectById(state, adjacentIds.idLeft)
      : undefined,
  )
  const fieldRight = useRootSelector((state) =>
    isNumberValid(adjacentIds?.idRight)
      ? Models.farmField.selectById(state, adjacentIds.idRight)
      : undefined,
  )

  if (fieldLeft && fieldRight) {
    return (
      <Row space={"$2"} {...rest}>
        <CycleButton
          {..._buttons}
          IconComponent={"ArrowLeft"}
          onPress={() =>
            onChangeField({
              centerLatLng: fieldLeft.centerLatLng,
              fieldId: fieldLeft.fieldId,
            })
          }
        />
        <CycleButton
          {..._buttons}
          IconComponent={"ArrowRight"}
          onPress={() =>
            onChangeField({
              centerLatLng: fieldRight.centerLatLng,
              fieldId: fieldRight.fieldId,
            })
          }
        />
      </Row>
    )
  }
  return null
}
